import { LOAD_SUCURSALES_MANY_SUCCESS } from "../types/sucursalActionTypes";
import {Sucursal} from "../../entities/catalogos/Sucursal";
import useCommonApi from "../../api/useCommonApi";

const apiSource = useCommonApi();

export function loadSucursalesMany() {
    return function (dispatch) {
        return apiSource.obtener<Sucursal[]>("sucursal/many")
            .then((sucursalesMany: Sucursal[]) => {
                dispatch({type: LOAD_SUCURSALES_MANY_SUCCESS, sucursalesMany})
            })
            .catch(error => {
                throw error;
            })
    }
}

